import "./App.css";
import CustomForm from "./components/costomForm/costumForm";

function App() {
  return (
    <div className="App mb-4">
      <CustomForm />
    </div>
  );
}

export default App;
